import { FunctionComponent } from "react";
import QPSFooterLogo from "assets/images/qps-footer-logo.png";

const Footer: FunctionComponent = () => {
  return (
    <div className="bg-white">
      <div className="flex justify-center items-center">
        <span className="w-full border border-gray-300"></span>
        <span className="px-4">
          <img
            src={QPSFooterLogo}
            className="cursor-pointer"
            alt="QPSoftware Footer Logo"
          />
        </span>
        <span className="w-full border border-gray-300"></span>
      </div>
      {/* <div className="container mx-auto mt-6 text-sm">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 p-3 md:p-0">
          <div>
            <div className="text-gray-400 uppercase font-extrabold text-sm mb-4">About us</div>
            <ul>
              <li><a className="text-qpblue-400 text-lg leading-8" href="https://qpsoftware.net/about-us/who-we-are">Who we are</a></li>
              <li><a className="text-qpblue-400 text-lg leading-8" href="https://qpsoftware.net/about-us/our-team">Our Team</a></li>
              <li><a className="text-qpblue-400 text-lg leading-8" href="https://qpsoftware.net/about-us/they-talk-about-us">They Talk About Us</a></li>
              <li><a className="text-qpblue-400 text-lg leading-8" href="https://qpsoftware.net/about-us/ceos-message">CEO’s Message</a></li>
              <li><a className="text-qpblue-400 text-lg leading-8" href="https://qpsoftware.net/about-us/methodology">Methodology</a></li>
              <li><a className="text-qpblue-400 text-lg leading-8" href="https://qpsoftware.net/about-us/careers">Careers</a></li>
              <li><a className="text-qpblue-400 text-lg leading-8" href="https://qpsoftware.net/contact-us">Contact Us</a></li>
            </ul>
          </div>
          <div>
            <div className="text-gray-400 uppercase font-extrabold text-sm mb-4">Our clients</div>
            <ul>
              <li><a className="text-qpblue-400 text-lg leading-8" href="https://qpsoftware.net/featured/lvmh-watches-jewelry">LVMH</a></li>
              <li><a className="text-qpblue-400 text-lg leading-8" href="https://qpsoftware.net/featured/schneider">Schneider Electric</a></li>
              <li><a className="text-qpblue-400 text-lg leading-8" href="https://qpsoftware.net/featured/air-france-klm">Air France KLM</a></li>
              <li><a className="text-qpblue-400 text-lg leading-8" href="https://qpsoftware.net/featured/economist">The Economist</a></li>
              <li><a className="text-qpblue-400 text-lg leading-8" href="https://qpsoftware.net/featured/duke-kunshan-university">Duke Kunshan University</a></li>
              <li><a className="text-qpblue-400 text-lg leading-8" href="https://qpsoftware.net/featured/erno-laszlo">Erno Laszlo</a></li>
            </ul>
          </div>
          <div>
            <div className="text-gray-400 uppercase font-extrabold text-sm mb-4">Our services</div>
            <ul>
              <li><a className="text-qpblue-400 text-lg leading-8" href="https://qpsoftware.net/services/ecommerce-china">E-commerce Solutions</a></li>
              <li><a className="text-qpblue-400 text-lg leading-8" href="https://qpsoftware.net/services/web-design-shanghai">Web Design Services</a></li>
              <li><a className="text-qpblue-400 text-lg leading-8" href="https://qpsoftware.net/services/crm-bi">Customized Software Services</a></li>
              <li><a className="text-qpblue-400 text-lg leading-8" href="https://qpsoftware.net/services/crm-bi/business-intelligence">Business Services</a></li>
              <li><a className="text-qpblue-400 text-lg leading-8" href="https://qpsoftware.net/services/mobile-app-agency-china">Mobile APP</a></li>
              <li><a className="text-qpblue-400 text-lg leading-8" href="https://qpsoftware.net/services/wechat-agency">WeChat Services</a></li>
              <li><a className="text-qpblue-400 text-lg leading-8" href="https://qpsoftware.net/services/seo-agency-china">Web Marketing/SEO Services</a></li>
            </ul>
          </div>
          <div>
            <div className="text-gray-400 uppercase font-extrabold text-sm mb-4">Our solutions</div>
            <ul>
              <li><a className="text-qpblue-400 text-lg leading-8" href="https://qpsoftware.net/solutions/drupal">Drupal</a></li>
              <li><a className="text-qpblue-400 text-lg leading-8" href="https://qpsoftware.net/solutions/magento">Magento</a></li>
              <li><a className="text-qpblue-400 text-lg leading-8" href="https://qpsoftware.net/solutions/ios-app">iOS</a></li>
              <li><a className="text-qpblue-400 text-lg leading-8" href="https://qpsoftware.net/solutions/prestashop">PrestaShop</a></li>
              <li><a className="text-qpblue-400 text-lg leading-8" href="https://qpsoftware.net/solutions/symfony">Symfony</a></li>
              <li><a className="text-qpblue-400 text-lg leading-8" href="https://qpsoftware.net/solutions/wechat-developer">WeChat</a></li>
              <li><a className="text-qpblue-400 text-lg leading-8" href="https://qpsoftware.net/solutions/android-app">Android</a></li>
              <li><a className="text-qpblue-400 text-lg leading-8" href="https://qpsoftware.net/solutions/wordpress">WordPress</a></li>
            </ul>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default Footer;
